import React from 'react';
import { useRealtimeInvalidation } from '../../hooks/useRealtimeInvalidation';

/** Global Socket.IO listener — revalidates system health, notifications, and outbox SWR keys. */
export const EmailRealtimeInvalidation: React.FC = () => {
  useRealtimeInvalidation(true);
  return null;
};
